import React from 'react';
import { acceptTeamInvite, getTeamInvite } from '@api/teamInvite';
import AcceptInvitePage from '@components/containers/invite/AcceptInvitePage';

/**
 * A colleague's way in, from the emailed link: set a password and land in the brand's
 * workspace as an admin. The page itself is shared with the other invite types.
 */
const AcceptTeamInvite: React.FC = () => (
    <AcceptInvitePage
        description="You've been invited to join your team on Reparo."
        fetchInvite={getTeamInvite}
        accept={acceptTeamInvite}
        landing="/home"
    />
);

export default AcceptTeamInvite;
